import { render, staticRenderFns } from "./projectProcess.vue?vue&type=template&id=10881854&scoped=true"
import script from "./projectProcess.vue?vue&type=script&lang=js"
export * from "./projectProcess.vue?vue&type=script&lang=js"
import style0 from "./projectProcess.vue?vue&type=style&index=0&id=10881854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10881854",
  null
  
)

export default component.exports